var _symbol, _symbol2, _symbol3, _symbol4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpritemedalsZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "gold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34 9.24399V10.364H15.612V9.24399H7.34ZM5.292 12.54V13.644H17.692V12.54H5.292ZM4.572 17.596V18.7H18.412V17.596H4.572ZM10.796 9.73999V18.156H12.076V9.73999H10.796ZM6.652 14.412C7.26 15.324 7.884 16.572 8.124 17.356L9.18 16.908C8.924 16.124 8.252 14.892 7.628 14.012L6.652 14.412ZM15.196 13.996C14.796 14.908 14.076 16.188 13.516 16.972L14.428 17.372C15.02 16.62 15.74 15.468 16.332 14.444L15.196 13.996ZM11.948 5.13199L10.94 5.62799C12.652 7.65999 15.628 9.64399 18.188 10.588C18.38 10.268 18.748 9.80399 19.036 9.53199C16.46 8.73199 13.468 6.92399 11.948 5.13199ZM11.468 4.29999C9.932 6.68399 6.988 8.57199 3.964 9.54799C4.268 9.83599 4.604 10.3 4.78 10.636C7.916 9.49999 10.844 7.45199 12.572 4.81199L11.468 4.29999Z",
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "silver",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.976 4.82801V5.88401H17.256V10.764H11.976V11.82H18.36V4.82801H11.976ZM12.024 7.82001V8.82801H17.736V7.82001H12.024ZM14.872 11.228L13.928 11.42C14.664 14.828 16.152 17.452 18.696 18.716C18.872 18.396 19.224 17.916 19.48 17.676C17.032 16.652 15.544 14.236 14.872 11.228ZM18.44 12.38C17.704 13.084 16.392 14.028 15.496 14.572L16.12 15.34C17.048 14.812 18.296 13.98 19.208 13.212L18.44 12.38ZM11.336 18.844C11.656 18.636 12.152 18.46 15.448 17.548C15.416 17.292 15.384 16.796 15.4 16.46L11.816 17.324L11.256 17.772L11.336 18.844ZM11.336 18.844C11.336 18.396 12.568 17.66 12.568 17.66V4.82801H11.384V16.716C11.384 17.372 11.048 17.708 10.792 17.852C10.984 18.076 11.256 18.572 11.336 18.844ZM6.84 4.15601C6.344 5.66001 5.496 7.08401 4.52 8.02801C4.728 8.30001 5.048 8.90801 5.144 9.16401C6.28 7.99601 7.32 6.23601 7.928 4.47601L6.84 4.15601ZM6.552 5.94801L6.312 7.08401H10.472V5.94801H6.552ZM5.752 8.79601V9.88401H10.248V8.79601H5.752ZM4.92 12.06V13.148H10.6V12.06H4.92ZM7.048 18.716C7.32 18.444 7.768 18.188 10.776 16.636C10.696 16.396 10.616 15.916 10.584 15.612L7.336 17.18L6.904 17.66L7.048 18.716ZM7.048 18.716C7.048 18.3 8.296 17.644 8.296 17.644V9.18001H7.16V16.652C7.16 17.292 6.808 17.564 6.552 17.692C6.728 17.932 6.968 18.444 7.048 18.716Z",
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "bronze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCB386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.368 4.852V18.836H12.392V5.956H18.424V4.852H11.368ZM18.168 4.852V17.364C18.168 17.588 18.088 17.668 17.864 17.668C17.64 17.684 16.872 17.684 16.088 17.652C16.232 17.972 16.408 18.5 16.44 18.804C17.48 18.804 18.216 18.772 18.648 18.596C19.064 18.388 19.192 18.02 19.192 17.364V4.852H18.168ZM13.304 7.556V8.564H17.304V7.556H13.304ZM13.576 10.164V15.924H14.392V10.164H13.576ZM14.072 10.164V11.14H16.184V14.036H14.072V14.996H17V10.164H14.072ZM7.14401 4.164C6.64801 5.652 5.78401 7.076 4.80801 8.02C5.01601 8.292 5.33601 8.9 5.43201 9.156C6.58401 8.004 7.60801 6.228 8.21601 4.468L7.14401 4.164ZM6.77601 5.908L6.56801 7.012H10.808V5.908H6.77601ZM7.12801 18.74C7.38401 18.468 7.83201 18.196 10.68 16.532C10.584 16.292 10.456 15.812 10.408 15.508L7.35201 17.188L6.95201 17.652L7.12801 18.74ZM5.99201 8.804V9.892H10.616V8.804H5.99201ZM5.17601 12.068V13.156H10.632V12.068H5.17601ZM7.12801 18.74C7.12801 18.292 8.48801 17.316 8.48801 17.316V9.092H7.36801V16.404C7.36801 17.156 6.84001 17.652 6.53601 17.86C6.74401 18.052 7.01601 18.5 7.12801 18.74Z",
    fill: "black"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "total",
    viewBox: "0 0 27 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6,
    r: 6,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18,
    r: 6,
    fill: "#DCB386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritemedalsZh);
export default __webpack_public_path__ + "static/media/Spritemedals_zh.639074c320950fac8449b71dff31ed15.svg";
export { ForwardRef as ReactComponent };